import { z } from 'zod';

export const CalendarSchema = z.object({
  id: z.number().optional(),
  name: z.string().min(1, 'Название обязательно'),
  description: z.string().optional(),
  weeklySpecialDays: z
    .array(
      z.object({
        id: z.number(),
        type: z.literal(1).or(z.literal(3)), // Enforce type to be exactly 1 or 3
        weekDay: z.number()
      })
    )
    .min(1, 'Должен быть хотя бы один выходной день'), // Ensure at least 1 item
  specialDays: z
    .array(
      z.object({
        id: z.number(),
        type: z.number(),
        day: z.string()
      })
    )
    .optional()
});
